import BlankProviderBill from "../blankProviderBill";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import TableBillProvider from "../../table/table-bill-provider";
import {
  getProviderBills,
  clearBillsList,
} from "../../../../Redux/actions/billActions";
import {
  getProviderBills as getBillsProvider,
  getTotalElements,
} from "../../../../Redux/reducer/bills";

const ApprovedList = (props) => {
  const dispatch = useDispatch();
  const defaultObj = {
    page: 0,
    sizePerPage: 10,
    filters: [{ property: "status", operator: "eq", value: "APPROVED" }],
  };

  const [tableObj, setTableObj] = useState(defaultObj);
  const bills = useSelector((state) => getBillsProvider(state));
  const totalElements = useSelector((state) => getTotalElements(state));

  useEffect(() => {
    async function fecthData() {
      var customFilters = getFilters();
      return await dispatch(
        getProviderBills(defaultObj.page, defaultObj.sizePerPage, customFilters)
      );
    }

    fecthData().then(() => props.setModal(false));

    return () => {
      dispatch(clearBillsList());
      props.updateCreditLine({});
      props.setModal(true);
    };
  }, [props.filters]);

  const getFilters = () => {
    var customFilters = [...props.filters, ...defaultObj.filters];
    setTableObj({ ...tableObj, filters: customFilters });
    return customFilters;
  };

  const getBillsHandler = async (
    page,
    sizePerPage,
    paramfilters,
    sortFilter
  ) => {
    props.setModal(true);
    return await dispatch(
      getProviderBills(page, sizePerPage, paramfilters, sortFilter)
    ).then(() => {
      setTableObj({ ...tableObj, page, sizePerPage });
      props.setModal(false);
    });
  };

  return bills.length > 0 ? (
    <TableBillProvider
      data={bills}
      page={tableObj.page}
      getProviderBills={getBillsHandler}
      totalSize={totalElements}
      sizePerPage={tableObj.sizePerPage}
      filters={tableObj.filters}
      updateCreditLine={props.updateCreditLine}
      approvedTo={`VALIDATED`}
      rejectedTo={`REJECTED`}
      mode="approved"
    />
  ) : (
    <BlankProviderBill />
  );
};

export default ApprovedList;
